import React from 'react';
import {ButtonBase} from '@material-ui/core';
import QCTooltip from '@pluto/qc-tooltip';
import {
    VolumeUp,
    VolumeOff,
} from '@material-ui/icons';

export interface VolumeButtonProps {
    muted: boolean;
    muteButtonDisabled: boolean;
    onToggleMute: (event: any) => void;
}

export default function VolumeButton(props: VolumeButtonProps) {
    const {
        muted,
        muteButtonDisabled,
        onToggleMute,
    } = props;
    
    if (muted) {
        return (
            <QCTooltip
                title="Mute/Unmute (M)"
                arrow
            >
                <ButtonBase
                    onClick={onToggleMute}
                    aria-label="Unmute"
                    aria-keyshortcuts="M"
                    className="volume-button"
                    disabled={muteButtonDisabled}
                >
                    <VolumeOff />
                </ButtonBase>
            </QCTooltip>
        );
    }
    
    return (
        <QCTooltip
            title="Mute/Unmute (M)"
            arrow
        >
            <ButtonBase
                onClick={onToggleMute}
                aria-label="Mute"
                aria-keyshortcuts="M"
                className="volume-button"
            >
                <VolumeUp />
            </ButtonBase>
        </QCTooltip>
    );
}
